import Alpine from 'alpinejs';

export function recItem(data, context) {
	const can_open_video = typeof context.open_video === 'function';
	context = Alpine.reactive(context);

	const item = {
		open_video() {
			can_open_video && context.open_video(this.video);
			return can_open_video;
		}
	};

	Object.assign(item, data);

	return item;
}